import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Card, CardContent, Grid, Chip, Divider,
} from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { ReportCompanyData } from 'services/dataService';
import { TrendingUp, AttachMoney, PersonOutline } from '@material-ui/icons';
import { useStyles } from './styles';
import { Pagination } from '@material-ui/lab';


export default function LogsDeAtividade() {
  const classes = useStyles();
  const { id } = useParams();
  const [logs, setLogs] = useState([]);
  const [count, setCount] = useState([]);
  const [page, setPage] = useState(1);
  const [tipoEvento, setTipoEvento] = useState('');
  const pageSize = 30;
  const [resumo, setResumo] = useState({
    totalConclusoes: 0,
    totalAulas: 0,
    mediaNota: 0,
    totalPage: 0,
  });
  const [allCount, setAllCount]= useState({
    progress: 0,
    exams: 0,
    conclusion: 0,
    enrollment: 0,
  })

  async function fetchData(currentPage = 1, tipoEventoValue = tipoEvento) {
    const params = {
      page: currentPage,
      limit: 30,
      tipo_evento: tipoEventoValue,
    };
    const result = await ReportCompanyData.getUsersLogs(id, params);
    const logsData = result?.data || [];

    const totalAulas = logsData.logsUser.filter((l) => l.tipo_evento === 'Aula assistida').length;
    const totalConclusoes = logsData.logsUser.filter((l) => l.tipo_evento === 'Avaliação concluída').length;
    const avaliacoes = logsData.logsUser.filter((l) => l.score !== null);
    const mediaNota = avaliacoes.length
      ? (avaliacoes.reduce((acc, cur) => acc + Number(cur.score), 0) / avaliacoes.length).toFixed(1)
      : 0;
    const totalPage = logsData.totalPage;

    setAllCount({
      progress:  logsData.totals['Aula assistida'] || 0,
      exams:  logsData.totals['Avaliação concluída'] || 0,
      conclusion:  logsData.totals['Conclusão do curso'] || 0,
      enrollment:  logsData.totals['Matrícula no curso'] || 0,
    })

    setResumo({ totalConclusoes, totalAulas, mediaNota, totalPage });
    setCount(logsData.totalCount, logsData.totals);

    setLogs(logsData.logsUser);
    setPage(Number(logsData.currentPage) || 1);
  }

  useEffect(() => {
    fetchData(1);
  }, [id]);


  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>Logs de Atividade</Typography>

      <Grid container spacing={2}>
      <Grid item xs={12} sm={3}>
          <Card>
            <CardContent>
              <Typography variant="h6">
                Total de Atividades
              </Typography>
              <Typography variant="h3">{resumo.totalPage}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Card>
            <CardContent>
              <Typography variant="h6">Total de Aulas Assistidas</Typography>
              <Typography variant="h3">{allCount.progress}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Card><CardContent>
            <Typography variant="h6">Total de Matrículas</Typography>
            <Typography variant="h3">{allCount.enrollment}</Typography>
          </CardContent></Card>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Card>
            <CardContent>
              <Typography variant="h6">Total de Conclusões</Typography>
              <Typography variant="h3">{allCount.conclusion}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
        <Divider style={{marginTop: 25}}/>
      <Box mt={2} mb={2}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={4}>
            <Typography variant="h5">Histórico de Atividades</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <select
              value={tipoEvento}
              onChange={(e) => {
                const value = e.target.value;
                setTipoEvento(value);
                fetchData(1, value); 
              }}
              style={{
                padding: '8px',
                borderRadius: 4,
                width: '100%',
                fontSize: '1rem',
              }}
            >
              <option value="">Todos</option>
              <option value="Login">Login</option>
              <option value="Aula assistida">Aula assistida</option>
              <option value="Avaliação concluída">Avaliação concluída</option>
              <option value="Matrícula no curso">Matrícula no curso</option>
              <option value="Conclusão do curso">Conclusão do curso</option>
            </select>
          </Grid>
        </Grid>
      </Box>

      <Box mt={2}>
        {logs.map((log, index) => (
          <Card key={index} style={{ marginBottom: 16 }}>
            <CardContent>
              {/* Chips */}
              <Box className={classes.status} gap={1} mb={1} flexWrap="wrap">
                {log.tipo_evento === 'Login' && (
                  <Chip label="Login" className={classes.chipLogin} size="small" />
                )}
                {log.tipo_evento === 'Aula assistida' && (
                  <>
                    <Chip label="Aula assistida" className={classes.chipProgress} size="small" />
                  </>
                )}
                {log.tipo_evento === 'Avaliação concluída' && (
                  <>
                    <Chip label="Avaliação concluída" className={classes.chipExam} size="small" />
                    <Chip label={`Nota: ${(log.score) * 100}`} size="small" />
                  </>
                )}
                {log.tipo_evento === 'Matrícula no curso' && (
                  <>
                    <Chip label="Matrícula no curso" className={classes.chipEnrollment} size="small" />
                  </>
                )}
                {log.tipo_evento === 'Conclusão do curso' && (
                  <>
                    <Chip label="Conclusão do curso" className={classes.chipConclusion} size="small" />
                  </>
                )}
              </Box>

              {/* Título e curso */}
              <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                {log.lesson_title || 'Acesso à plataforma'}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {log.course_name}
              </Typography>

              {/* Hora/Data */}
              <Box className={classes.actions} mt={2}>
                <Typography variant="h6" color="textSecondary">
                  {log.hora}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        ))}
        {logs.length > 0 && (
          <Box display="flex" justifyContent="center" mt={3}>
            <Pagination
              count={Math.ceil(count / pageSize)}
              page={page}
              onChange={(e, value) => fetchData(value, tipoEvento)}
              color="primary"
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}
